<div class="carousel">
  <div
    class="carousel-track"
    [style.transform]="'translateX(-' + currentIndex() * 100 + '%)'"
    [style.transition]="'transform 400ms ease'"
  >
    <ng-content></ng-content>
  </div>

  @if (totalItems() > 1) {
    <div class="carousel-dots">
      <bw-icon-legacy (click)="prev()" [iconName]="'chevron_left'"></bw-icon-legacy>
      @for (i of dotsIndices(); track i) {
        <span
          (click)="goTo(i)"
          [class.active]="i === currentIndex()"
        ></span>
      }
      <bw-icon-legacy (click)="next()" [iconName]="'chevron_right'"></bw-icon-legacy>
    </div>
  }
</div>
